export function getTempDisablementPageStyle() {
    return {
        root: {
            height: "100%",
            width: "61vw",
        },
    };
}
export function getVersionComponentIconStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textPrimary,
        },
    };
}
export function getButtonStyle() {
    return {
        root: {
            marginTop: 20,
            minWidth: "150px",
        },
    };
}
